function n(n,c,i,o){n._m(c),n.o(c,"AnimatedIcon",()=>n.f(a));var a=n.i(i("5c6d0721"));}